module.exports = __webpack_public_path__ + "images/error-unplug-c452c6c195d106267629484cd145bd8f.png";